import { useLayoutEffect, useState } from 'react';
import * as am5 from "@amcharts/amcharts5";
import * as am5xy from "@amcharts/amcharts5/xy";
import am5themes_Animated from "@amcharts/amcharts5/themes/Animated";

function CalibrationCurveChart(props) {



  useLayoutEffect(() => {
    var root = am5.Root.new("chartdiv");


// Set themes
// https://www.amcharts.com/docs/v5/concepts/themes/
root.setThemes([
  am5themes_Animated.new(root)
]);


// Create chart
// https://www.amcharts.com/docs/v5/charts/xy-chart/
var chart = root.container.children.push(am5xy.XYChart.new(root, {
  panX: true,
  panY: true,
  wheelX: "panX",
  wheelY: "zoomXY",
  pinchZoomX: true,
  paddingLeft: 0
}));

chart.get("colors").set("step", 3);

let cursor = chart.set("cursor", am5xy.XYCursor.new(root, {}));
    // cursor.lineY.set("visible", false);
    // cursor.lineX.set("visible", false);



// Create axes
// https://www.amcharts.com/docs/v5/charts/xy-chart/axes/
var xAxis = chart.xAxes.push(am5xy.ValueAxis.new(root, {
  maxDeviation: 0.2,
//   baseInterval: {
//     timeUnit: "day",
//     count: 1
//   },
  renderer: am5xy.AxisRendererX.new(root, {
    minorGridEnabled: false,
    minGridDistance: 70,
    

    // strokeWidth:2
  }),
  tooltip: am5.Tooltip.new(root, {})
}));


var yAxis = chart.yAxes.push(am5xy.ValueAxis.new(root, {
  maxDeviation: 0.2,
  renderer: am5xy.AxisRendererY.new(root, {
    minorGridEnabled: false,

  }),
  tooltip: am5.Tooltip.new(root, {})
}));

// xAxis.get("renderer").grid.template.set("forceHidden", true);
// yAxis.get("renderer").grid.template.set("forceHidden", true);

xAxis.get("renderer").grid.template.setAll({
  strokeOpacity: 0.1 // Adjust opacity (0 = fully transparent, 1 = fully visible)
});
yAxis.get("renderer").grid.template.setAll({
  strokeOpacity: 0.1 // Adjust opacity (0 = fully transparent, 1 = fully visible)
});

yAxis.children.moveValue(am5.Label.new(root, { text: "Detector Response", rotation: -90, y: am5.p50, centerX: am5.p50 }), 0);
xAxis.children.push(am5.Label.new(root, { text: "Concentration (mg/L)", x: am5.p50, centerX: am5.p50 }));






var series = chart.series.push(am5xy.LineSeries.new(root, {
  // name: "ic cal",
  xAxis: xAxis,
  yAxis: yAxis,
  valueYField: "y",
  valueXField: "x",

  // tooltip: am5.Tooltip.new(root, {
  //   labelText: "{valueY}"
  // })
}));

let series0 = chart.series.push(am5xy.LineSeries.new(root, {
  // calculateAggregates: true,
  xAxis: xAxis,
  yAxis: yAxis,
  valueYField: "y",
  valueXField: "x",
  tooltip: am5.Tooltip.new(root, {
    labelText: `x: {valueX}, y: {valueY}`
  })
}));



series0.strokes.template.set("strokeOpacity", 0);

series0.bullets.push(function() {
  var graphics = am5.Graphics.new(root, {
    strokeWidth: 2,
    stroke: series.get("stroke"),
    draw: function(display, target) {
      var dataItem = target.dataItem;

      var error = dataItem.dataContext.error;

      var yPosition0 = yAxis.valueToPosition(0);
      var yPosition1 = yAxis.valueToPosition(error);

      var height =
        (yAxis.get("renderer").positionToCoordinate(yPosition1) - yAxis.get("renderer").positionToCoordinate(yPosition0)) / 2;

      display.moveTo(0, -height);
      display.lineTo(0, height);

      display.moveTo(-10, -height);
      display.lineTo(10, -height);

      display.moveTo(-10, height);
      display.lineTo(10, height);
    }
  });

  return am5.Bullet.new(root, {
    dynamic: true,
    sprite: graphics
  });
});

series0.bullets.push(function() {
  var graphics = am5.Circle.new(root, {
    strokeWidth: 2,
    radius: 5,
    stroke: series.get("stroke"),
    fill: root.interfaceColors.get("background"),
    tooltipText: `x: {valueX}\ny: {valueY}\nerror: {error}`,
  });
  return am5.Bullet.new(root, {
    sprite: graphics
  });
});



series0.data.setAll(props.chartBullets);
series.data.setAll(props.data)


return () => {
  root.dispose();
};
  });


  return (
    <>
      <div id="chartdiv" style={{width:'100%', height: '100%'}}></div>
    </>
  );
}
export default CalibrationCurveChart;